import * as api from "../api/fotos";
import { START_PROGRESS, STOP_PROGRESS } from "./progress";
import { showNotification } from "./notification";

export const UPLOAD_FOTOS_SUCCESS = "UPLOAD_FOTOS_SUCCESS";
export const UPLOAD_FOTOS_FAIL = "UPLOAD_FOTOS_FAIL";
export const LOAD_FOTOS_SUCCESS = "LOAD_FOTOS_SUCCESS";
export const LOAD_FOTOS_FAIL = "LOAD_FOTOS_FAIL";
export const DELETE_FOTO_SUCCESS = "DELETE_FOTO_SUCCESS";
export const DELETE_FOTO_FAIL = "DELETE_FOTO_FAIL";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";

export const startLoading = () => ({
  type: START_LOADING,
});

export const stopLoading = () => ({
  type: STOP_LOADING,
});

export const uploadFotosAction = (produtoId, descricao, arquivos) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.uploadFotos(produtoId, descricao, arquivos);
    dispatch({ type: UPLOAD_FOTOS_SUCCESS, payload: data });
    dispatch(
      showNotification({
        message: "Fotos enviadas com sucesso!",
        color: "success",
      })
    );
    return data;
  } catch (error) {
    console.error("Erro ao enviar fotos:", error);
    dispatch({
      type: UPLOAD_FOTOS_FAIL,
      payload: error.message || "Erro ao enviar as fotos.",
    });
    dispatch(
      showNotification({
        message: error?.message || "Erro ao enviar as fotos.",
        color: error?.type || "failure",
      })
    );
    throw error;
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const loadFotosAction =
  ({ lojaId, page = 1, limit = 30, search = "", sortOrder = "newest" }) =>
  async (dispatch) => {
    try {
      dispatch({ type: START_PROGRESS });

      const { data } = await api.getFotosPorLoja(lojaId, {
        page,
        limit,
        search,
        sortOrder,
      });

      dispatch({ type: LOAD_FOTOS_SUCCESS, payload: data });
    } catch (error) {
      console.error("Erro ao carregar fotos:", error);
      dispatch({
        type: LOAD_FOTOS_FAIL,
        payload: error.message || "Erro ao carregar as fotos.",
      });
    } finally {
      dispatch({ type: STOP_PROGRESS });
    }
  };

export const deletarFotoAction = (fotoId) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });

    await api.deletarFoto(fotoId);

    dispatch({ type: DELETE_FOTO_SUCCESS, payload: fotoId });
    dispatch(
      showNotification({
        message: "Foto excluída com sucesso!",
        color: "success",
      })
    );
    return true;
  } catch (error) {
    console.error("Erro ao excluir foto:", error);
    dispatch({
      type: DELETE_FOTO_FAIL,
      payload: error.message || "Erro ao excluir a foto.",
    });
    dispatch(
      showNotification({
        message: error?.message || "Erro ao excluir a foto.",
        color: error?.type || "failure",
      })
    );
    throw error;
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};
